// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__envgH","modalClose":"styles_modalClose__ACFfL","modalMain":"styles_modalMain__wtru7"};